import { useAccess } from '../auth/AccessContext';
import { useT } from '../lib/i18n';
import { PersonRecord } from './PersonRecord';

/**
 * "Meu Perfil" — every signed-in collaborator's own ficha. The person is
 * resolved from the login (`/permissions/modules/me` → personId, matched via
 * the ficha User Name field). Managers may edit; others view read-only. When no
 * ficha matches the login yet, a short explanation is shown instead.
 */
export function MyProfile() {
  const { access, loading } = useAccess();
  const t = useT();

  if (loading) return <p className="muted">{t('common.loading')}</p>;

  if (!access?.personId) {
    return (
      <section>
        <div className="page-head">
          <h2>{t('people.profile.title')}</h2>
        </div>
        <div className="alert warn">
          {t('people.profile.noFicha.before')}
          <strong>User Name</strong>
          {t('people.profile.noFicha.after')}
        </div>
      </section>
    );
  }

  return <PersonRecord personId={access.personId} selfMode />;
}
